import _regeneratorRuntime from "@babel/runtime/regenerator";
import createAsyncAction from './create-async-action';
import bindActionType from './bind-action-type';
import validateActionType from './validate-action-type';
import createActionFactory from './action-factory';
/**
 * Returns a function which generates actions of the given type.
 * @param type A unique name which describes the action.
 * @param effect Something to run when the action is invoked. Whatever it
 * returns becomes the action payload.
 * @example
 * createAction('settings/load-theme', () => {
 *   return localStorage.getItem('theme')
 * })
 */

// Synchronous action creator.
//
// Example:
// createAction('add-file', file => {
//   return { url: URL.createObjectURL(file) }
// })
export default function createAction(actionType, effect) {
  validateActionType(actionType);

  function executeEffectAndReturnAction(input) {
    // This action is free of side effects.
    if (effect === undefined) {
      if (input === undefined) {
        return {
          type: actionType
        };
      } // The caller explicitly provided a payload.


      return {
        type: actionType,
        payload: input
      };
    } // If given an effect, whatever it returns becomes the payload.


    return {
      type: actionType,
      payload: effect(input)
    };
  }

  return bindActionType(actionType, /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
    var action, _action;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            action = executeEffectAndReturnAction(input);
            _context.next = 4;
            return action;

          case 4:
            return _context.abrupt("return", action.payload);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            _action = {
              type: actionType,
              error: true,
              payload: _context.t0
            };
            _context.next = 12;
            return _action;

          case 12:
            throw _context.t0;

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
} // Asynchronous action creator.
//
// Example:
// createAction.async('update-profile-photo', async photo => {
//   await http.put('/users/self/profile-photo/', photo)
// })

createAction.async = createAsyncAction; // Advanced usage: action factory for generator functions.

createAction.factory = createActionFactory; // If an effect is provided, we have to assume it can fail.